import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { Language } from "../../models/language";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { MatStepper } from "@angular/material/stepper";
import { MatChipInputEvent, MatChipGrid } from "@angular/material/chips";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, } from "@angular/forms";
import { AddCvLangDialogComponent } from "./add-cv-lang-dialog/add-cv-lang-dialog.component";
import { MatAutocomplete, MatAutocompleteSelectedEvent, } from "@angular/material/autocomplete";
import { DeleteCvLangDialogComponent } from "./delete-cv-lang-dialog/delete-cv-lang-dialog.component";
import { Cv } from "../../models/cv";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../services/authentication.service";
import { User } from "../../models/user";
import { CvService } from "../../services/cv.service";
import { InjectDialogComponent } from "../inject-dialog/inject-dialog.component";
import { DialogService } from "../../services/dialog.service";


@Component({
    selector: "app-add-cv",
    templateUrl: "./add-cv.component.html",
    styleUrls: ["./add-cv.component.scss"],
})
export class AddCvComponent implements OnInit {
    personalInfoFormGroup: UntypedFormGroup;
    educationFormGroup: UntypedFormGroup;
    characteristicsFormGroup: UntypedFormGroup;

    saveError: boolean = false;

    languages: string[] = [
        "Македонски",
        "Албански",
        "Англиски",
        "Бугарски",
        "Германски",
        "Грчки",
        "Италиjански",
        "Норвешки",
        "Полски",
        "Романски",
        "Руски",
        "Словачки",
        "Словенски",
        "Српски",
        "Турски",
        "Украински",
        "Француски",
        "Хрватски",
        "Чешки",
        "Шветски",
        "Шпански",
    ];

    faculties: string[] = [
        "Архитектура",
        "Градежен",
        "Економски",
        "Машински",
        "Медицински",
        "Педагошки",
        "Правен",
        "Природно-математички",
        "Стоматолошки",
        "Технолошко-металуршки",
        "Ветеринарна медицина",
        "Дизајн и технологии на мебел и ентериер",
        "Драмски уметности",
        "ФЕИТ",
        "ФИНКИ",
        "ФИКТ",
        "Земјоделски науки и храна",
        "Ликовни уметности",
        "Музичка уметност",
        "Физичка култура",
        "Фармацевтски",
        "Филозофски",
        "Филолошки",
        "Шумарски",
        "Факултет за Информатика - Штип",
        "Факултет за администрација и менаџмент на информациски системи - Битола",
        'Универзитет за информатички технологии и науки "Свети Апостол Павле" - Охрид',
        'Универзитет "Гоце Делчев" - Штип',
        "Педагошки факултет - Битола",
        "Факултетот за туризам и угостителство (ФТУ) - Охрид",
        "Правен факултет - Кичево",
        "Правен факултет Кичево, дисперзирани студии Битола",
        "Правен факултет Кичево - дисперзирани студии Струга",
        "Факултет за биотехнички хауки - Битола",
        "Висока медицинска школа - Битола",
        "Технички факултет - Битола",
        "ФОН Универзитет",
        "Европски Универзитет",
        "ЈИЕ Универзитет",
        "Универзитет за Туризам и Менаџмент - Скопје",
        "University American College - Скопје",
        "МИТ Универзитет",
        "Универзитет за Аудиовизуелни уметности - ЕСРА",
        "Меѓународен Универзитет Струга",
        "International Balcan University",
        'Универзитет "Aгнез Гонџе Бојаџиу"',
    ];

    studentYear: string[] = [
        "I",
        "II",
        "III",
        "IV",
        "V",
        "VI",
        "Дипломиран",
        "Маг. 1",
        "Маг. 2",
        "Магистриран",
    ];

    secondaryLanguages: Language[] = [];

    displayedColumns: string[] = [
        "name",
        "hearing",
        "reading",
        "interaction",
        "speaking",
        "writing",
        "actions",
    ];

    computerSkills: string[] = [
        ".Net",
        "3ds Max",
        "AJAX",
        "ARCHICAD",
        "ASP.Net",
        "Adobe Creative Studio",
        "Adobe Flash",
        "Adobe Premiere",
        "AfterEffects",
        "Android",
        "AutoCAD",
        "Bootstrap",
        "C",
        "C#",
        "C++",
        "CSS",
        "Cisco",
        "CorelDraw",
        "Delphi",
        "Django",
        "Excel",
        "GitHub",
        "HTML",
        "Hibernate",
        "IOS",
        "Illustrator",
        "JSON",
        "Java",
        "JavaScript",
        "Joomla",
        "Laravel",
        "MathLab",
        "Maya",
        "Node.js",
        "Objective-C",
        "Photoshop",
        "PowerPoint",
        "Python",
        "Rubi on Rails",
        "SQL",
        "Spring",
        "Swift",
        "Unit Tests",
        "Unix",
        "Word",
        "WordPress",
        "XML",
        "angularJS",
        "jQuery",
        "php",
    ];

    professionalSkills: string[] = [
        "Јавно говорење",
        "Емоционална интелигенција",
        "Комуникациски вештини",
        "Креативност",
        "Лидерство",
        "Мотивираност",
        "Одговорност",
        "Организациски вештини",
        "Посветеност",
        "Преговарачки вештини",
        "Презентациски вештини",
        "Прилагодливост",
        "Работа под притисок",
        "Способност за менаџирање со време",
        "Стратешко планирање",
        "Тимски играч",
    ];

    separatorKeysCodes: number[] = [ENTER, COMMA];

    computerSkillControl = new UntypedFormControl();
    $filteredCompSkills: Observable<string[]>;
    selectedCompSkillArray: string[] = [];

    profSkillControl = new UntypedFormControl();
    $filteredProfSkills: Observable<string[]>;
    selectedProfSkillArray: string[] = [];

    @ViewChild("compSkillInput") compSkillInput: ElementRef<HTMLInputElement>;
    @ViewChild("compSkillAutocomplete") compSkillAutocomplete: MatAutocomplete;

    @ViewChild("profSkillInput") profSkillInput: ElementRef<HTMLInputElement>;
    @ViewChild("profSkillAutocomplete") profSkillAutocomplete: MatAutocomplete;

    @ViewChild("stepper") stepper: MatStepper;

    @ViewChild("compChipList") computerChipList: MatChipGrid;
    @ViewChild("profChipList") profChipList: MatChipGrid;

    currentUser: User;

    constructor(private formBuilder: UntypedFormBuilder,
        private authService: AuthenticationService,
        private cvService: CvService,
        private dialogService: DialogService,
        private router: Router) {
        this.authService.loggedInUser$.subscribe(x => this.currentUser = x);
        if (this.currentUser == null)
            router.navigateByUrl("/home/login");

        this.$filteredCompSkills = this.computerSkillControl.valueChanges.pipe(
            startWith(<string>null),
            map((skill: string | null) =>
                skill ? this._filter(this.computerSkills, skill) : this.computerSkills.slice()
            )
        );

        this.$filteredProfSkills = this.profSkillControl.valueChanges.pipe(
            startWith(<string>null),
            map((skill: string | null) =>
                skill ? this._filter(this.professionalSkills, skill) : this.professionalSkills.slice()
            )
        );
    }

    ngOnInit(): void {
        this.personalInfoFormGroup = this.formBuilder.group({
            firstNameControl: ['', Validators.required],
            lastNameControl: ['', Validators.required],
            birthPlaceControl: ['', Validators.required],
            birthDateControl: ['', Validators.required],
            addressControl: ['', Validators.required],
            phoneControl: ['', Validators.required],
            linkedinURLControl: '',
            workInterestControl: ['', Validators.required],
        });

        this.educationFormGroup = this.formBuilder.group({
            workExperienceControl: '',
            facultyControl: ['', Validators.required],
            yearControl: ['', Validators.required],
            facultyPathControl: ['', Validators.required],
            meanGradeControl: ['', Validators.required],
            highSchoolControl: ['', Validators.required],
            schoolTypeControl: ['', Validators.required],
            cityControl: ['', Validators.required],
            certificateControl: '',
        });

        this.characteristicsFormGroup = this.formBuilder.group({
            motherTongueControl: ['', Validators.required],
            computerSkillControl: [],
            profSkillsControl: [],
            remainingInfoControl: '',
        });
    }

    saveCV() {
        this.compChipValidate();
        this.profChipValidate();

        /*  We only need to validate the last step,
         *   because if one of the previous step is invalid,
         *   you can't get to the next step
         */
        if (this.characteristicsFormGroup.valid) {
            const pGroup = this.personalInfoFormGroup;
            const eGroup = this.educationFormGroup;
            const cGroup = this.characteristicsFormGroup;

            let cv: Cv = {
                firstName: pGroup.get("firstNameControl").value,
                lastName: pGroup.get("lastNameControl").value,
                birthPlace: pGroup.get("birthPlaceControl").value,
                birthDate: pGroup.get("birthDateControl").value,
                address: pGroup.get("addressControl").value,
                phone: pGroup.get("phoneControl").value,
                linkedInURL: pGroup.get("linkedinURLControl").value,
                workInterest: pGroup.get("workInterestControl").value,

                workExperience: eGroup.get("workExperienceControl").value,
                faculty: eGroup.get("facultyControl").value,
                year: eGroup.get("yearControl").value,
                facultyPath: eGroup.get("facultyPathControl").value,
                meanGrade: +eGroup.get("meanGradeControl").value,
                highSchool: eGroup.get("highSchoolControl").value,
                schoolType: eGroup.get("schoolTypeControl").value,
                city: eGroup.get("cityControl").value,
                certificate: eGroup.get("certificateControl").value,

                motherTongue: cGroup.get("motherTongueControl").value,
                secondaryLanguages: this.secondaryLanguages,
                computerSkills: this.selectedCompSkillArray.toString(),
                professionalSkills: this.selectedProfSkillArray.toString(),
                remainingInfo: cGroup.get("remainingInfoControl").value,
                // confirmation: cGroup.get("finalConfirmation").value,
            };

            this.cvService.sendCv(cv).then(() => {
                this.dialogService.openDialog(InjectDialogComponent, {
                    title: 'Успешно',
                    content: 'Вашето CV е успешно зачувано во базата на податоци.'
                });
            }).catch(err => {
                this.dialogService.openDialog(InjectDialogComponent, {
                    title: 'Неуспешно',
                    content: 'Проблем со комуникација со серверот. Обидете се повторно!'
                });
                console.error(err);
            });            
        }
    }

    clearCV() {
        this.secondaryLanguages = [];
        this.selectedCompSkillArray = [];
        this.selectedProfSkillArray = [];
        this.personalInfoFormGroup.reset();
        this.educationFormGroup.reset();
        this.characteristicsFormGroup.reset();
        this.stepper.reset();
    }

    compChipValidate() {
        this.computerChipList.errorState = this.selectedCompSkillArray.length === 0;
        if (this.selectedCompSkillArray.length != 0)
            this.characteristicsFormGroup.controls["computerSkillControl"].setErrors(
                null
            );
        else
            this.characteristicsFormGroup.controls["computerSkillControl"].setErrors({
                invalid: true,
            });
    }

    profChipValidate() {
        this.profChipList.errorState = this.selectedProfSkillArray.length === 0;
        if (this.selectedProfSkillArray.length != 0)
            this.characteristicsFormGroup.controls["profSkillsControl"].setErrors(
                null
            );
        else
            this.characteristicsFormGroup.controls["profSkillsControl"].setErrors({
                invalid: true,
            });
    }

    addCompSkill(event: MatChipInputEvent): void {
        this.add(this.selectedCompSkillArray, this.computerSkillControl, event);
        this.compChipValidate();
    }

    addProfSkill(event: MatChipInputEvent): void {
        this.add(this.selectedProfSkillArray, this.profSkillControl, event);
        this.profChipValidate();
    }

    add(array: string[], control: UntypedFormControl, event: MatChipInputEvent): void {
        const input = event.chipInput.inputElement;
        const value = event.value;

        if ((value || "").trim()) {
            array.push(value.trim());
        }

        if (input) {
            input.value = "";
        }

        control.setValue(null);
    }

    removeCompSkill(skill: string) {
        this.remove(this.selectedCompSkillArray, skill);
        this.compChipValidate();
    }

    removeProfSkill(skill: string): void {
        this.remove(this.selectedProfSkillArray, skill);
        this.profChipValidate();
    }

    remove(array: string[], skill: string): void {
        const index = array.indexOf(skill);

        if (index >= 0) array.splice(index, 1);
    }

    selectedComp(event: MatAutocompleteSelectedEvent): void {
        this.selectedCompSkillArray.push(event.option.viewValue);
        this.compSkillInput.nativeElement.value = "";
        this.computerSkillControl.setValue(null);

        this.compChipValidate();
    }

    selectedProf(event: MatAutocompleteSelectedEvent): void {
        this.selectedProfSkillArray.push(event.option.viewValue);
        this.profSkillInput.nativeElement.value = "";
        this.profSkillControl.setValue(null);

        this.profChipValidate();
    }

    addSecondaryLanguage() {
        this.dialogService.openDialog(AddCvLangDialogComponent, {
            secondaryLanguage: Language,
        }).afterClosed().subscribe((result) => {
            if (result != undefined || result != null)
                this.secondaryLanguages = this.secondaryLanguages.concat(result);
        });
    }

    deleteSecondaryLanguage(element: Language) {
        this.dialogService.openDialog(DeleteCvLangDialogComponent, {
            name: element.name,
        }).afterClosed().subscribe((result) => {
            if (result) {
                const index = this.secondaryLanguages.indexOf(element);

                if (index >= 0) {
                    this.secondaryLanguages.splice(index, 1);
                    this.secondaryLanguages = [...this.secondaryLanguages];
                }
            }
        });
    }

    private _filter(array: string[], value: string): string[] {
        const filterValue = value.toLowerCase();

        return array.filter(
            (skill) => skill.toLowerCase().indexOf(filterValue) === 0
        );
    }
}
